import { IOrderType } from 'shared/models/IOrderType'

export const getOrderTypesDisplay = (
  orderTypes: string,
  possibleOrderTypes: IOrderType[]
): string => {
  if (!possibleOrderTypes) {
    return orderTypes
  }

  const types = orderTypes
    .split(',')
    .map(t => +t)
    .sort((a, b) => a - b)

  if (possibleOrderTypes.length != types.length) {
    return orderTypes
  } else if (
    possibleOrderTypes.filter(t => !types.some(o => o === t.value)).length > 0
  ) {
    return orderTypes
  } else {
    return 'Alle'
  }
}
